// extracted by mini-css-extract-plugin
export default {"section":"TaxesOnboardingTaxRate_section__SNQ9m"};